import React from "react";
//import videoSourceGas from "../Assets/Trabaja con nosotros Web.mp4";
import { useTranslation } from "react-i18next";
import NAVBAR from "./NavBarNueva";
import NAVBARMOBILE from "./NavBarMobile";
import "./Vexen.css";

const Vexen = () => {
  // eslint-disable-next-line no-unused-vars
  const [t, i18next] = useTranslation("global");

  return (
    <>
      <div className="ContainerVexen">
          <div className="BarraEscritorio">
            <NAVBAR></NAVBAR>
          </div>
          <div className="BarraMobile">
            <NAVBARMOBILE></NAVBARMOBILE>
          </div>
          <div className="content-vexen">
            <div className="txt-container-vexen">
              <img 
                src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_Logo Blanco.png" 
                alt="Vexen Logo" 
                className="logo-vexen"
              />
              <p className="txt-vexen">{t("txtVexen.txt1")}</p>
              <div className="botones-vexen">
                <a 
                  href="https://wa.me/56998493146"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-vexen btn-cotizacion"
                >
                  {t("txtVexen.txt2")}
                </a>
                {/*<a 
                  href="https://www.canva.com/design/DAG5urR7lww/aaWnI7FYGu47j73l2ha9Aw/view?utm_content=DAG5urR7lww&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h8a5053b4a2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-vexen btn-informacion"
                >
                  {t("txtVexen.txt3")}
                </a>*/}
              </div>
            </div>
          </div>
          <div className="redes-container-vexen">
              <a
                href="https://www.instagram.com/vexen.cl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img 
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/instagram.png" 
                  alt="Instagram" 
                  className="icono-red-social" 
                />
              </a>
              <a
                href="https://www.facebook.com/CCNChileLubricantes"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img 
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/facebook.png" 
                  alt="Facebook" 
                  className="icono-red-social" 
                />
              </a>
            </div>
      </div>
      <div className="banner-vexen">
        <img 
          src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 2.png" 
          alt="Vexen Banner" 
          className="img-banner-vexen"
        />
      </div>
      <div className="divider-vexen"></div>
      <div className="section-vexen">
        <div className="container-section-vexen">
          <div className="content-left-vexen">
            <div className="content-with-line-vexen">
              <div className="title-with-line-vexen">
                <div className="vertical-line-vexen"></div>
                <h2 className="title-section-vexen">{t("txtVexenQuienes.txt1")}</h2>
              </div>
              <p className="text-section-vexen">
                  {t("txtVexenQuienes.txt2")}
                  <span className="txt-spanQuienes-Vexen">
                    {" "}
                    {t("txtVexenQuienes.txt3")}
                  </span>
                  {" "}
                  {t("txtVexenQuienes.txt4")}
                  <br></br>
                  <br></br>
                    {t("txtVexenQuienes.txt5")}
              </p>
            </div>
          </div>
          <div className="content-right-vexen">
            <img 
              src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 3.png" 
              alt="Vexen" 
              className="img-section-vexen"
            />
          </div>
        </div>
      </div>
      <div className="virtudes-vexen">
        <div className="container-virtudes-vexen">
          <div className="section-virtudes-vexen">
            <div className="content-wrapper-virtudes-vexen">
              <div className="content-text-virtudes-vexen">
                <h3 className="title-virtudes-vexen">{t("txtVexenVirtudes.txt1")}</h3>
                <p className="text-virtudes-vexen">{t("txtVexenVirtudes.txt2")}</p>
              </div>
              <div className="empty-space-virtudes-vexen"></div>
            </div>
          </div>
          <div className="divider-dotted-vexen"></div>
          <div className="section-virtudes-vexen">
            <div className="content-wrapper-virtudes-vexen">
              <div className="content-text-virtudes-vexen">
                <h3 className="title-virtudes-vexen">{t("txtVexenVirtudes.txt3")}</h3>
                <p className="text-virtudes-vexen">{t("txtVexenVirtudes.txt4")}</p>
              </div>
              <div className="empty-space-virtudes-vexen"></div>
            </div>
          </div>
          <div className="divider-dotted-vexen"></div>
          <div className="section-virtudes-vexen">
            <div className="content-wrapper-virtudes-vexen">
              <div className="content-text-virtudes-vexen">
                <h3 className="title-virtudes-vexen">{t("txtVexenVirtudes.txt5")}</h3>
                <p className="text-virtudes-vexen">{t("txtVexenVirtudes.txt6")}</p>
              </div>
              <div className="empty-space-virtudes-vexen"></div>
            </div>
          </div>
          <div className="divider-dotted-vexen"></div>
          <div className="section-virtudes-vexen">
            <div className="content-wrapper-virtudes-vexen">
              <div className="content-text-virtudes-vexen">
                <h3 className="title-virtudes-vexen">{t("txtVexenVirtudes.txt7")}</h3>
                <p className="text-virtudes-vexen">{t("txtVexenVirtudes.txt8")}</p>
              </div>
              <div className="empty-space-virtudes-vexen"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="divider-vexen-1"></div>
      <div className="banner-vexen">
        <img 
          src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 9.png" 
          alt="Vexen Banner" 
          className="img-banner-vexen"
        />
      </div>
      <div className="section-final-vexen">
        <div className="container-final-vexen">
          <div className="content-image-final-vexen">
            <img 
              src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 4.png" 
              alt="Vexen" 
              className="img-final-vexen"
            />
          </div>
          <div className="content-text-final-vexen">
            <div className="content-with-line-cobertura-vexen">
              <div className="title-with-line-cobertura-vexen">
                <div className="vertical-line-cobertura-vexen"></div>
                <h3 className="title-cobertura-vexen">{t("txtVexenCobertura.txt1")}</h3>
              </div>
              <p className="text-cobertura-vexen">{t("txtVexenCobertura.txt2")}</p>
              <ul className="list-cobertura-vexen">
                <li className="list-item-cobertura-vexen">
                  <span className="list-region-cobertura-vexen">{t("txtVexenCobertura.txt3")}</span>
                  <span className="list-city-cobertura-vexen">{t("txtVexenCobertura.txt4")}</span>
                </li>
                <li className="list-item-cobertura-vexen">
                  <span className="list-region-cobertura-vexen">{t("txtVexenCobertura.txt5")}</span>
                  <span className="list-city-cobertura-vexen">{t("txtVexenCobertura.txt6")}</span>
                </li>
                <li className="list-item-cobertura-vexen">
                  <span className="list-region-cobertura-vexen">{t("txtVexenCobertura.txt7")}</span>
                  <span className="list-city-cobertura-vexen">{t("txtVexenCobertura.txt8")}</span>
                </li>
                <li className="list-item-cobertura-vexen">
                  <span className="list-region-cobertura-vexen">{t("txtVexenCobertura.txt9")}</span>
                  <span className="list-city-cobertura-vexen">{t("txtVexenCobertura.txt10")}</span>
                </li>
              </ul>
              <p className="text-cobertura-vexen">{t("txtVexenCobertura.txt11")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="banner-vexen">
        <img 
          src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 5.png" 
          alt="Vexen Banner" 
          className="img-banner-vexen"
        />
      </div>
      <div className="divider-vexen"></div>
      <div className="section-productos-vexen">
        <div className="container-productos-vexen">
          <div className="content-left-productos-vexen">
            <div className="content-with-line-productos-vexen">
              <div className="title-with-line-productos-vexen">
                <div className="vertical-line-productos-vexen"></div>
                <h3 className="title-productos-vexen">{t("txtVexenProductos.txt1")}</h3>
              </div>
              <p className="text-productos-vexen">
                {t("txtVexenProductos.txt2")}
                {" "}
                <span className="txt-span-productos-vexen">{t("txtVexenProductos.txt3")}</span>
                {t("txtVexenProductos.txt4")}
                {" "}
                <span className="txt-span-productos-vexen">{t("txtVexenProductos.txt5")}</span>
              </p>
              <ul className="list-productos-vexen">
                <li className="list-item-productos-vexen">{t("txtVexenProductos.txt6")}</li>
                <li className="list-item-productos-vexen">{t("txtVexenProductos.txt7")}</li>
                <li className="list-item-productos-vexen">{t("txtVexenProductos.txt8")}</li>
              </ul>
            </div>
          </div>
          <div className="content-right-productos-vexen">
            <img 
              src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 6.png" 
              alt="Vexen Productos" 
              className="img-productos-vexen"
            />
          </div>
        </div>
      </div>
      <div className="banner-vexen">
        <img 
          src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 7.png" 
          alt="Vexen Banner" 
          className="img-banner-vexen"
        />
      </div>
      <div className="divider-vexen"></div>
      <div className="banner-vexen">
        <img 
          src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/VEXEN_ IMAGEN 8.png" 
          alt="Vexen Banner" 
          className="img-banner-vexen"
        />
      </div>
      <div className="section-respaldo-vexen">
        <div className="container-respaldo-vexen">
          <div className="content-left-respaldo-vexen">
            <div className="content-with-line-respaldo-vexen">
              <div className="title-with-line-respaldo-vexen">
                <div className="vertical-line-respaldo-vexen"></div>
                <h3 className="title-respaldo-vexen">{t("txtVexenRespaldo.txt1")}</h3>
              </div>
              <p className="text-respaldo-vexen">
                {t("txtVexenRespaldo.txt2")}
                {" "}
                <span className="txt-span-respaldo-vexen">{t("txtVexenRespaldo.txt3")}</span>
                {" "}
                {t("txtVexenRespaldo.txt4")}
                {" "}
                <span className="txt-span-respaldo-vexen">{t("txtVexenRespaldo.txt5")}</span>
                {t("txtVexenRespaldo.txt6")}
                {" "}
                <span className="txt-span-respaldo-vexen">{t("txtVexenRespaldo.txt7")}</span>
              </p>
              <p className="text-respaldo-vexen">{t("txtVexenRespaldo.txt8")}</p>
            </div>
          </div>
          <div className="content-right-respaldo-vexen">
            <div className="timeline-vexen">
              <div className="timeline-item-vexen">
                <div className="timeline-dot-vexen"></div>
                <div className="timeline-content-vexen">
                  <h4 className="timeline-title-vexen">{t("txtVexenRespaldo.txt9")}</h4>
                  <p className="timeline-text-vexen">{t("txtVexenRespaldo.txt10")}</p>
                </div>
              </div>
              <div className="timeline-item-vexen">
                <div className="timeline-dot-vexen"></div>
                <div className="timeline-content-vexen">
                  <h4 className="timeline-title-vexen">{t("txtVexenRespaldo.txt11")}</h4>
                  <p className="timeline-text-vexen">{t("txtVexenRespaldo.txt12")}</p>
                </div>
              </div>
              <div className="timeline-item-vexen">
                <div className="timeline-dot-vexen"></div>
                <div className="timeline-content-vexen">
                  <h4 className="timeline-title-vexen">{t("txtVexenRespaldo.txt13")}</h4>
                  <p className="timeline-text-vexen">{t("txtVexenRespaldo.txt14")}</p>
                </div>
              </div>
              <div className="timeline-item-vexen">
                <div className="timeline-dot-vexen"></div>
                <div className="timeline-content-vexen">
                  <h4 className="timeline-title-vexen">{t("txtVexenRespaldo.txt15")}</h4>
                  <p className="timeline-text-vexen">{t("txtVexenRespaldo.txt16")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-ubicacion-vexen">
        <div className="container-ubicacion-vexen">
          <div className="content-left-ubicacion-vexen">
            <div className="content-with-line-ubicacion-vexen">
              <div className="title-with-line-ubicacion-vexen">
                <div className="vertical-line-ubicacion-vexen"></div>
                <h3 className="title-ubicacion-vexen">{t("txtVexenUbicacion.txt1")}</h3>
              </div>
              <p className="text-ubicacion-vexen">{t("txtVexenUbicacion.txt2")}</p>
            </div>
          </div>
          <div className="content-right-ubicacion-vexen">
            <div className="cards-container-ubicacion-vexen">
              <div className="card-ubicacion-vexen">
                <div className="card-left-ubicacion-vexen">
                  <img 
                    src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/ubicacion.png" 
                    alt="Dirección" 
                    className="icon-card-ubicacion-vexen"
                  />
                  <div className="divider-dotted-card-ubicacion-vexen"></div>
                </div>
                <div className="card-right-ubicacion-vexen">
                  <h4 className="title-card-ubicacion-vexen">{t("txtVexenUbicacion.txt3")}</h4>
                  <p className="text-card-ubicacion-vexen">{t("txtVexenUbicacion.txt4")}</p>
                </div>
              </div>
              <div className="card-ubicacion-vexen">
                <div className="card-left-ubicacion-vexen">
                  <img 
                    src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/contacto.png" 
                    alt="Contacto" 
                    className="icon-card-ubicacion-vexen"
                  />
                  <div className="divider-dotted-card-ubicacion-vexen"></div>
                </div>
                <div className="card-right-ubicacion-vexen">
                  <h4 className="title-card-ubicacion-vexen">{t("txtVexenUbicacion.txt5")}</h4>
                  <p className="text-card-ubicacion-vexen">{t("txtVexenUbicacion.txt6")}</p>
                </div>
              </div>
              <div className="card-ubicacion-vexen">
                <div className="card-left-ubicacion-vexen">
                  <img 
                    src="https://webcontent.cn-grupo.net/Media/Fotos/Vexen/mail.png" 
                    alt="Correo Electrónico" 
                    className="icon-card-ubicacion-vexen"
                  />
                  <div className="divider-dotted-card-ubicacion-vexen"></div>
                </div>
                <div className="card-right-ubicacion-vexen">
                  <h4 className="title-card-ubicacion-vexen">{t("txtVexenUbicacion.txt7")}</h4>
                  <p className="text-card-ubicacion-vexen">{t("txtVexenUbicacion.txt8")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-vexen">
        <div className="footer-left-vexen">
          <p className="txt-foo-vexen">{t("txt-foo2.Footer1")}</p>
        </div>
        <div className="footer-right-vexen">
          <div className="footer-right-left-vexen">
            <a
              href="https://webcontent.cn-grupo.net/Assets/Politica/CN-GRUPO_ Política de privacidad.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="txt-foo-politicas-vexen"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Politicas de privacidad
            </a>
          </div>
          <div className="footer-right-right-vexen">
            <p className="txt-foo2-vexen">{t("txt-foo2.Footer", { year: new Date().getFullYear() })}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vexen;